import React from "react";
import { Modal, Typography } from "antd";
import CustomTable from "../../Component/Table";
import { getAllUserActionByVisitID } from "../../Services/user_metrics";
import { useQuery } from "@tanstack/react-query";
import { formatDate } from "../../utils/date";

const { Title } = Typography;

const columns = [
//   {
//     title: "id",
//     dataIndex: "id",
//     key: "id",
//   },
  {
    title: "Date & Time",
    dataIndex: "created_at",
    key: "created_at",
    render: (text, record) =>
        record?.created_at ? formatDate(record.created_at) : "-",
  },
  {
    title: "Action Type",
    dataIndex: "action_type",
    key: "action_type",
    render: (text, record)=>
        record.action_type === 'page' ? 'Page Visit' : record.action_type==='event'? "Event": record.action_type
    
  },
  {
    title: "Action Sub-Type",
    dataIndex: "action_sub_type",
    key: "action_sub_type",
    render: (text, record)=>{
        const typeLabels = {
            budget: 'Budget',
            trip_duration: 'Trip Duration',
            food_preference: 'Food Preference',
            search: 'Search',
            selected_search: 'Selected Search',
            regenerate_response: 'Regenerate Response',
            share_itinerary: 'Share Itinerary',
            download: 'Download',
            add_to_calender: 'Add to Calender',
        };
        return typeLabels[record.action_sub_type] || record.action_sub_type
    }
  },
  {
    title: "Action Value",
    dataIndex: "action_value",
    key: "action_value",
    render: (text, record)=>{
        if (record.action_sub_type ==='budget') {
            return record.full_data?.currency +" " +record?.action_value
        }else{
            return record.action_value
        }
    }
  },
  {
    title: "Search Query",
    dataIndex: "query",
    key: "query",
  },
  {
    title: "Location Type",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Search Result",
    dataIndex: "results_count",
    key: "results_count",
    render: (text, record) =>{
        if (record.action_sub_type ==='search') {
            return record?.results_count >0  ? 'Success' : "Failed"
        }else{
            return ""
        }
    }
  },
  {
    title: "Trip Start Date",
    dataIndex: "start_date",
    key: "start_date",
  },
  {
    title: "Trip End Date",
    dataIndex: "end_date",
    key: "end_date",
  },
  {
    title: "Itinerary ID",
    dataIndex: "user_itinerary_id",
    key: "user_itinerary_id",
  },
  {
    title: "Category ID",
    dataIndex: "question_category_id",
    key: "question_category_id",
  },
];

const UserMetricsAction = ({ visible, onClose, data }) => {
    const { data:action_data, isLoading } = useQuery({
        queryKey: [`user-metrics-${data?.id}`],
        queryFn: () =>  getAllUserActionByVisitID(data?.session_ids),
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        retry: false,
        enabled: !!data?.id,
    });
    return (
        <Modal
            title={<Title level={4} style={{ margin: 0 }}>#{data?.id} - {data?.user?.name} User Actions</Title>}
            open={visible}
            onCancel={onClose}
            footer={null}
            width={'70%'}
            styles={{
                body: { maxHeight: "70vh", overflowY: "auto", padding: '5px' }
            }}
        >
            
            <CustomTable
            columns={columns}
            data={action_data}
            loading={isLoading}
            pagination={false}
            />
            
        </Modal>
    );
};

export default UserMetricsAction;
